import { HEALTHY_CONTRIBUTIONS_NAME } from '../../constants/companyNames';

export default {
    formatPageTitle: (title) => {
        return `${title} | ${HEALTHY_CONTRIBUTIONS_NAME}`;
    }
};